import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/map'
import { Injectable } from '@angular/core';

interface Data {
  type: string;
  massage: string;
}

type DataCallback = (massage: string) => void;

@Injectable()
export class SharedServiceService {

  constructor() { }

  private handler = new Subject<Data>();

  broadcast(type: string, massage: string) {
    this.handler.next({ type, massage });
  }

  subscribe(type: string, callback: DataCallback): Subscription {
    return this.handler
      .filter(data => data.type === type)
      .map(data => data.massage)
      .subscribe(callback);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-service.service.ts